import { CRBattles } from '@/routes/cr/CRBattles';

/** My battles — the existing CR screen, rendered in place instead of navigated to. */
export function BattlesPanel() {
  return (
    // -mx-4 cancels the Hub padding: <CRBattles /> brings its own px-4.
    <div className="-mx-4 h-full">
      <CRBattles />
    </div>
  );
}
